import {usersAPI} from "../api/api";
import {UserType} from "../types/types";

const SET_USERS = 'myFacebook/users/SET-USERS';
const SET_CURRENT_PAGE = 'myFacebook/users/SET_CURRENT_PAGE';
const SET_TOTAL_USERS_COUNT = 'myFacebook/users/SET_TOTAL_USERS_COUNT';
const TOGGLE_IS_FETCHING = 'myFacebook/users/TOGGLE_IS_FETCHING';


const initialState = {
    users: [] as UserType[],
    pageSize: 100,
    totalUsersCount: 0,
    currentPage: 10,
    isFetching: false,
}

export type initialStateType = typeof initialState;

const usersReducer = (state = initialState, action: any): initialStateType => {
    switch (action.type) {
        case SET_USERS:
            return {...state, users: [...state.users, ...action.users]}
        case SET_CURRENT_PAGE:
            return {...state, currentPage: action.currentPage}
        case SET_TOTAL_USERS_COUNT:
            return {...state, totalUsersCount: action.totalUsersCount}
        case TOGGLE_IS_FETCHING:
            return {...state, isFetching: action.isFetching}
        default:
            return state
    }
}

type setUsersType = {
    type: typeof SET_USERS
    users: UserType[]
}
export const setUsers = (users: UserType[]): setUsersType => ({type: SET_USERS, users});

type setCurrentPageType = {
    type: typeof SET_CURRENT_PAGE
    currentPage: number
}
export const setCurrentPage = (currentPage: number): setCurrentPageType => ({type: SET_CURRENT_PAGE, currentPage});

type setUsersTotalCountType = {
    type: typeof SET_TOTAL_USERS_COUNT
    totalUsersCount: number
}
export const setUsersTotalCount = (totalUsersCount: number): setUsersTotalCountType => ({
    type: SET_TOTAL_USERS_COUNT,
    totalUsersCount
});

type toggleIsFetchingType = {
    type: typeof TOGGLE_IS_FETCHING
    isFetching: boolean
}
export const toggleIsFetching = (isFetching: boolean): toggleIsFetchingType => ({type: TOGGLE_IS_FETCHING, isFetching});


//requestUsersThunkCreator
export const requestUsers = (page = 1, pageSize = 100) => {
    return async (dispatch: any) => {
        dispatch(setCurrentPage(page));
        dispatch(toggleIsFetching(true));
        let [users, totalCount] = await usersAPI.requestUsers(page, pageSize)
        
        dispatch(toggleIsFetching(false));
        dispatch(setUsers(users));
        dispatch(setUsersTotalCount(Math.ceil(totalCount)));
    }
}

export default usersReducer;
